import React, { Component } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import ModalRegister from '../../Containers/Modal_Register';
import ModalLogin from '../../Containers/Modal_Login';
import Popup from '../../Components/Popup';
import axios from 'axios';
import './style.scss';

export default class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowPopup: false,
      buttonActive: false,
      errorMessage: '',
      title: '',
      body: '',
      input: {},
    };
    this.handlerButtonSubmitPassword =
      this.handlerButtonSubmitPassword.bind(this);
    this.handlerButtonPupup = this.handlerButtonPupup.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  handleInput(value, id) {
    const { input } = this.state;
    input[id] = value;
    this.setState({
      input: { ...input },
      errorMessage: '',
    });
    if (input['new_password'].length < 6) {
      this.setState({
        errorMessage: 'Mật khẩu của bạn phải có 6 kí tự trở lên.',
        buttonActive: false,
      });
    }
    if (
      input['new_password'] &&
      input['confirm_password'] &&
      input['new_password'] !== input['confirm_password']
    ) {
      this.setState({
        errorMessage: 'Xác nhận mật khẩu không kớp.',
        buttonActive: false,
      });
    }
    if (
      input['new_password'] &&
      input['confirm_password'] &&
      input['new_password'] === input['confirm_password']
    ) {
      this.setState({
        errorMessage: '',
        buttonActive: true,
      });
    }
  }

  handlerButtonPupup() {
    this.setState({
      isShowPopup: false,
    });
  }

  handlerButtonSubmitPassword(e) {
    e.preventDefault();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const { token } = Object.fromEntries(urlSearchParams.entries());
    axios
      .post(`/api/v1/resetpassword/${token}`, { ...this.state.input })
      .then(({ data }) => {
        if (data.success) {
          this.setState({
            isShowPopup: true,
            title: 'Thành công!',
            body: 'Thay đổi mật khẩu thành công.',
          });
        } else {
          this.setState({
            isShowPopup: true,
            title: 'Thất bại',
            body: 'Thay đổi mật khẩu thất bại.',
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    const { isShowPopup, buttonActive, errorMessage, title, body } = this.state;

    return (
      <div className='reset-password'>
        <Header />
        <main>
          <div className='form-reset-password'>
            <h2>Thay đổi mật khẩu</h2>
            <form
              action=''
              method=''
              onSubmit={this.handlerButtonSubmitPassword}
            >
              <div className='form-group'>
                <label>Mật khẩu mới</label>
                <input
                  id='password-field-3'
                  type='password'
                  name='new_password'
                  placeholder=''
                  onChange={(e) =>
                    this.handleInput(e.target.value, 'new_password')
                  }
                />
                <span
                  toggle='#password-field-3'
                  className='toggle-password'
                  style={{ backgroundImage: 'url(/assets/img/icon-hide.png)' }}
                ></span>
              </div>
              <div className='form-group'>
                <label>Xác nhận mật khẩu mới</label>
                <input
                  id='password-field-4'
                  type='password'
                  name='confirm_password'
                  placeholder=''
                  onChange={(e) =>
                    this.handleInput(e.target.value, 'confirm_password')
                  }
                />
                <span
                  toggle='#password-field-4'
                  className='toggle-password'
                  style={{ backgroundImage: 'url(/assets/img/icon-hide.png)' }}
                ></span>
              </div>
              <p className='text-error text-danger'>
                {errorMessage ? errorMessage : ''}
              </p>
              <button
                type='submit'
                className={`btn_reset-password ${
                  buttonActive ? 'active' : 'disable'
                }`}
                disabled={buttonActive ? false : true}
              >
                Thay đổi mật khẩu
              </button>
            </form>
          </div>
          {isShowPopup && (
            <Popup
              buttunStyle='btn-danger'
              handle={this.handlerButtonPupup}
              onClosePopup={this.handlerButtonPupup}
              title={title}
              body={body}
              labelButton={'Tiếp tục'}
            />
          )}
          <ModalLogin />
          <ModalRegister />
        </main>
        <Footer />
      </div>
    );
  }
}
